import React, { useState, useMemo, useEffect } from 'react';
import {
  Button,
  IconButton,
  Typography,
  TextField,
  Menu,
  MenuItem,
} from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import { Formik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { StyledForm, ButtonFlex, FormRow } from '../../../styles/styles';
import SimpleSelect from '../../../util/SimpleSelect';
import FieldModal from './FieldModal';
import RenderPropModal from '../../../dealMapper/common/RenderPropModal';
import { safeEval } from '../../../util/UtilFunctions';

const TransactionStyle = css`
  .tranFields {
    margin-left: 10px;
  }
  .dtNumberLine {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  margin-bottom: 10px;
  margin-top: 2rem;
`;

const DisabledInputStyles = css`
  .MuiFormLabel-root.Mui-disabled {
    color: #757575;
  }
  .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.15);
  }

  :hover {
    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: rgba(0, 0, 0, 0.35);
    }
  }
`;

const DTFormPreview = ({ dt, i, deleteDT, json, updateTemplateJSON }) => {
  const { template, items } = json;
  const { dataStore } = useRootStore();
  const [selectedField, setSelectedField] = useState({});

  const typeEnums = ['AP', 'AR', 'JE'];

  return (
    <Formik
      initialValues={dt}
      enableReinitialize
      // validationSchema={DealTemplateSchema(items)}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        console.log('SUBMIT');
        try {
          console.log('TIME TO UPDATE', values);

          const newDTs = json.template.DealTransactions.slice();

          newDTs[i] = values;

          updateTemplateJSON({
            template: {
              Deals: json.template.Deals,
              DealTransactions: newDTs,
            },
            items: json.items,
          });

          resetForm();
        } catch (e) {
          console.error(e);
        }
        setSubmitting(false);
        // setLoading(false);
      }}
      render={formikProps => {
        const {
          handleSubmit,
          isSubmitting,
          isValid,
          handleChange,
          handleBlur,
          values,
          dirty,
          setFieldValue,
        } = formikProps;
        //   console.log(values);

        // const contactObj = safeEval(
        //   () => dataStore.getContactFromId(values.ContactId).Name,
        //   values.ContactId,
        // );

        // console.log(toJS(contactObj));

        const tranCatVal = safeEval(
          () => dataStore.getTranCategoryFromId(values.TranCategoryId).Code,
          values.TranCategoryId,
        );

        return (
          <RenderPropModal
            cardDisplay={({ handleClose }) => (
              <FieldModal
                handleClose={handleClose}
                setValueForParent={setFieldValue}
                selectedField={selectedField}
                setSelectedField={setSelectedField}
                items={items}
                updateTemplate={handleSubmit}
              />
            )}
          >
            {({ handleOpen }) => (
              <StyledForm
                style={{ alignItems: 'inherit' }}
                css={TransactionStyle}
                onSubmit={handleSubmit}
              >
                <div className="dtNumberLine">
                  <Typography variant="h5">{`Deal Transaction #${i +
                    1}`}</Typography>

                  <IconButton aria-label="Delete" onClick={() => deleteDT(i)}>
                    <DeleteIcon />
                  </IconButton>
                </div>
                <div className="tranFields">
                  <FormRow>
                    <SimpleSelect
                      label="Type"
                      handleChange={async e => {
                        await handleChange(e);
                        handleSubmit();
                      }}
                      value={values.TranType || ''}
                      name="TranType"
                      css={DisabledInputStyles}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {typeEnums.map(typeEnum => (
                        <MenuItem key={typeEnum} value={typeEnum}>
                          {typeEnum}
                        </MenuItem>
                      ))}
                    </SimpleSelect>
                    <TextField
                      name="Price"
                      label="Price"
                      value={values.Price || ''}
                      margin="normal"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                      inputProps={{
                        style: { cursor: 'pointer', color: '#263238' },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      disabled
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'Price',
                          label: 'Price',
                          curVal: values.Price,
                          fieldType: 'dollar',
                        });
                        handleOpen();
                      }}
                    />
                    <TextField
                      name="Quantity"
                      label="Quantity"
                      value={values.Quantity || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: { cursor: 'pointer', color: '#263238' },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'Quantity',
                          label: 'Quantity',
                          curVal: values.Quantity,
                          fieldType: 'string',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <TextField
                      name="ContactName"
                      label="Contact"
                      value={values.ContactName || ''}
                      // value={contactObj || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: { cursor: 'pointer', color: '#263238' },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'ContactName',
                          label: 'Contact',
                          curVal: values.ContactName,
                          fieldType: 'contact',
                          // FIXME: contact + agent
                        });
                        handleOpen();
                      }}
                    />

                    <TextField
                      name="TranCategoryId"
                      label="Transaction Category"
                      value={tranCatVal || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: { cursor: 'pointer', color: '#263238' },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'TranCategoryId',
                          label: 'Transaction Category',
                          curVal: values.TranCategoryId,
                          fieldType: 'tranCategory',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>

                  <TextField
                    name="Description"
                    label="Description"
                    value={values.Description || ''}
                    disabled
                    margin="normal"
                    inputProps={{
                      style: { cursor: 'pointer', color: '#263238' },
                    }}
                    floatingLabelStyle={{
                      color: '#757575 !important',
                    }}
                    css={DisabledInputStyles}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    onClick={() => {
                      setSelectedField({
                        name: 'Description',
                        label: 'Description',
                        curVal: values.Description,
                        fieldType: 'string',
                      });
                      handleOpen();
                    }}
                  />
                </div>
              </StyledForm>
            )}
          </RenderPropModal>
        );
      }}
    />
  );
};

export default DTFormPreview;
